import { logFormData } from 'shared/lib/logFormData';

import type { TAdditionalDataFormFields } from 'entities/creditForm';
import { setAdditionalInfo, sendStepsAnalyticsEvents } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';

export const submitAdditionalInfoForm =
  (actualData: TAdditionalDataFormFields): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('AdditionalInfo FormStep SubmitData', actualData);
    dispatch(setAdditionalInfo({ data: actualData, isFullFilled: true }));
    dispatch(sendStepsAnalyticsEvents([4], AdditionalInfoTexts, 'manual'));
  };
